import { useEffect, useState } from 'react';
import { explainTerm } from '../api.js';

/**
 * 用語解説のボトムシート。タップした用語の平易な解説を表示する。
 * 解説はサーバーでキャッシュされるため、2回目以降は即表示される。
 */
export function TermPopup({
  ja,
  zh,
  onClose,
}: {
  ja: string;
  zh: string;
  onClose: () => void;
}): JSX.Element {
  const [explanation, setExplanation] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    setExplanation(undefined);
    setError(undefined);
    explainTerm(ja, zh)
      .then((res) => {
        if (!cancelled) setExplanation(res.explanation);
      })
      .catch((e: unknown) => {
        if (!cancelled) setError(e instanceof Error ? e.message : '解説を取得できませんでした。');
      });
    return () => {
      cancelled = true;
    };
  }, [ja, zh]);

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 70, background: 'rgba(0,0,0,.45)' }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          background: 'var(--bg-raised, #161b22)',
          borderRadius: '14px 14px 0 0',
          padding: '16px 18px calc(18px + env(safe-area-inset-bottom))',
          maxHeight: '55vh',
          overflowY: 'auto',
        }}
      >
        <div className="row" style={{ alignItems: 'baseline', marginBottom: 8 }}>
          <strong style={{ fontSize: 19 }}>{ja}</strong>
          {zh && (
            <span className="hint" style={{ fontSize: 13 }}>
              {zh}
            </span>
          )}
          <div className="spacer" />
          <button style={{ minHeight: 36, padding: '4px 12px', fontSize: 13 }} onClick={onClose}>
            閉じる
          </button>
        </div>
        {error ? (
          <div className="notice error">{error}</div>
        ) : explanation === undefined ? (
          <p className="hint" style={{ margin: 0 }}>解説を用意しています…(初回のみ数秒)</p>
        ) : (
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.75 }}>{explanation}</p>
        )}
      </div>
    </div>
  );
}
